module.exports = __webpack_public_path__ + "static/media/CM-marca_reduzida-negativa-RGB.debdeefa.svg";